import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  > span {
    background-color: #fff;
    padding: 0.5rem;
    border-radius: 8px;
    font-size: ${(props) => props.theme.font.text2xl};
    font-weight: 900;
  }
`
